module.exports = __webpack_public_path__ + "static/img/h_section_bg.0904a4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2.0/mobile/h_section_bg.png
// module id = yU8R
// module chunks = 0